import { render, staticRenderFns } from "./MainIndex.vue?vue&type=template&id=3521efbe"
import script from "./MainIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MainIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MainIndex.vue?vue&type=style&index=0&id=3521efbe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports